import { generateKeys } from '../utils';
export const pushNotificationTypes = generateKeys({
    marketing: {
        label: 'Marketing',
        value: 'marketing',
    },
    marketingOptimove: {
        label: 'Marketing Optimove',
        value: 'marketing_optimove',
    },
    transactional: {
        label: 'Transactional',
        value: 'transactional',
    },
});
